import SubMenu from 'common/navigation/components/sub-menu';
import MainMenu from 'common/navigation/containers/main-menu-container';
import Wrapper from 'common/navigation/wrapper';
import React from 'react';
import { Navigate, Outlet, Route, Routes, useParams } from 'react-router-dom';
import { ticketObjectRoutes } from '../common/navigation/routes/cops-routes';
import TicketWorklistContainer from '../tickets/containers/list/ticket-worklist-container';
import NotificationCallDetailsContainer from './containers/notification_call-container';

const NotificationRoutes = () => {
  const { notificationId } = useParams();
  // As notifications and calls use the same component, we will determine what we want to show
  // via the match params.
  const id = notificationId;
  const renderMenu = (actionButtons, extraLinks = []) =>
    <MainMenu type={'notification'} id={id} actionButtons={actionButtons}>
      <SubMenu
        id={id}
        baseType='notification'
        hasInfo={false}
        hasTickets={true}
        dashboardTranslation='nav.subNav.DETAILS'
        base={`notification/${id}`}
        extraLinks={[
          ...extraLinks,
        ]}
      />
    </MainMenu>;
  const ticketRoutes = ticketObjectRoutes();
  return (
    <Wrapper title={'Notification'}>
      <Routes>
        <Route
          path={'dashboard/*'}
          element={<NotificationCallDetailsContainer
            renderMenu={renderMenu} id={id} isNotification={true}
          />}
        />
        {ticketRoutes?.map((r, i) => <Route
          path={`${r}/*`}
          key={i}
          element={
            <TicketWorklistContainer
              renderMenu={renderMenu}
              isNotificationCall={true}
              baseType='notification'
            />
          }
        />)}
        <Route
          path='/*'
          element={<Navigate to='dashboard' replace />}
        />
      </Routes>
      <Outlet />
    </Wrapper>
  );
};

NotificationRoutes.propTypes = {};

export default NotificationRoutes;
